import React from 'react';
import { Inline, xcss } from '@atlaskit/primitives';
import { TruncateWithTooltipOnHover } from '@atlassian/jira-command-palette';
import { IssueCommandLeftIcon } from '@atlassian/jira-command-palette-common';
import { useIssueTypeField } from '@atlassian/jira-issue-field-issue-type';
import { useSummaryField } from '@atlassian/jira-issue-field-summary';

export type IssueTagProps = {
	issueKey: string;
};

export const IssueTag = ({ issueKey }: IssueTagProps) => {
	const [{ value: summary }] = useSummaryField({ issueKey });
	const [{ value: issueType }] = useIssueTypeField({ issueKey });

	return (
		<Inline xcss={issueTagContainerStyles}>
			<Inline xcss={issueTagStyles} space="space.050" alignBlock="center">
				<IssueCommandLeftIcon issueTypeName={issueType?.name} iconUrl={issueType?.iconUrl} />
				<TruncateWithTooltipOnHover>{`${issueKey} ${summary}`}</TruncateWithTooltipOnHover>
			</Inline>
		</Inline>
	);
};

const issueTagContainerStyles = xcss({
	width: '100%',
	minWidth: '0',
});

const issueTagStyles = xcss({
	maxWidth: '100%',
	padding: 'space.050',
	backgroundColor: 'color.background.neutral',
	borderRadius: 'border.radius.100',
	fontSize: '14px',
	color: 'color.text.subtle',
	lineHeight: 1,
});
